import React from 'react'
import { Tile } from '@mc/design-system'
import Image from 'components/LegacyImage'
import Link from 'components/Link/CustomLink'
import { trackRelatedContentCarouselTileClick } from './events'

export const RelatedContentTile = ({
  title,
  subtitle,
  imageUrl,
  aspectRatio,
  href,
  slug,
}: {
  title: string
  subtitle: string
  imageUrl: string
  aspectRatio: '16x9' | '1x1'
  href: string
  slug: string
}) => {
  if (!imageUrl) return <></>

  return (
    <div className='mc-px-1'>
      <Tile aspectRatio={aspectRatio}>
        <Link
          ariaHidden
          href={href}
          tabIndex={-1}
          onClick={() => {
            trackRelatedContentCarouselTileClick(slug)
          }}
          passHref
        >
          <Image
            src={imageUrl}
            className='mc-corners--3'
            layout='fill'
            objectFit='cover'
            alt=''
          />
        </Link>
      </Tile>
      <div className='mc-mt-3'>
        <p className='mc-text-h6'>{title}</p>
        <p className='mc-text-small mc-opacity--hinted mc-text--2-lines'>
          {subtitle}
        </p>
      </div>
    </div>
  )
}
